<template>
<section class="container callout-wrapper">
  <div class="row">
    <div class="col-lg-6">
      <figure class="call-out-image">
        <img :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/ad_campaign/image/${callout.calloutImage}`"  class="image-fluid" alt="" role="presentation"/>
      </figure>
    </div>
    <div class="col-lg-6 d-flex flex-column justify-content-center">
      <h2 class="featured-exp-call-out-title"> {{callout.calloutTitle}} </h2>
      <p v-html="callout.calloutSubtext"></p>
      <div>
        <a class="button" :href="callout.calloutLink">
            Learn More
            <span class="ani-chevron"> > </span>
        </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  data() {
    return {
    };
  },
  computed: {
    // target() {
    //   const url = new RegExp('http');
    //   const u = `${this.featuredExperience.url}`;
    //   if (url.test(u)) {
    //     return true;
    //   }
    //   return false;
    // },
  },
})
class CampaignCallout1 extends Vue {
  @Prop({
    type: [Object],
    required: true,
  })
    callout;
}

export default CampaignCallout1;
</script>

<style scoped>
section {
  margin-top: 75px;
  margin-bottom: 75px;
}
h2 {
  line-height:60px;
}
a.router-link-active:hover{
  color:#ffffff;
  text-decoration: underline;
}
.callout-wrapper {
  margin-top: 164px;
  margin-bottom: 164px;
}
.call-out-image {
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  max-height: 272px;
  overflow: hidden;
}
.featured-exp-call-out-title{
  height: 60px!important;
}
.image-fluid {
  width:100%;
}
@media only screen and (max-width: 768px) {
.featured-exp-call-out-title{
  height: auto!important;
  line-height: 45px;
}
}
</style>
